export const STRIPE_PUBLISHABLE_KEY = `${process.env.REACT_APP_STRIPE_PUBLISH_KEY}`;
